export default {
  small: 744,
  medium: 1128,
  large: 1440,
  xlarge: Infinity
}
